<mat-accordion>
  <mat-expansion-panel [expanded]="this.step?.event?.selectedIndex-1 === 0" hideToggle>
    <mat-expansion-panel-header>
      <mat-panel-title>
        <div class="title_wrap">
          <span class="number">1</span>
          <span class="title">Warehouse Name</span>
        </div>

      </mat-panel-title>
    </mat-expansion-panel-header>
    <div class="wrapper">
      <img src="../../../../assets/img/fname_icon.svg" alt="icon" class="icon">
      <div class="wrap">
        <span class="label">Name*</span>
        <span class="value">{{warehouse?.name}}</span>
      </div>
    </div>
    <div class="wrapper">
      <img src="../../../../assets/img/email_2_icon.svg" alt="icon" class="icon">
      <div class="wrap">
        <span class="label">Email*</span>
        <span class="value">{{warehouse?.email}}</span>
      </div>
    </div>
    <div class="wrapper">
      <img src="../../../../assets/img/phone_icon.svg" alt="icon" class="icon">
      <div class="wrap">
        <span class="label">Phone*</span>
        <span class="value">{{warehouse?.phone}}</span>
      </div>
    </div>
    <div class="wrapper">
      <img src="../../../../assets/img/fax_icon.svg" alt="icon" class="icon">
      <div class="wrap">
        <span class="label">Fax</span>
        <span class="value">{{warehouse?.fax}}</span>
      </div>
    </div>
  </mat-expansion-panel>
  <mat-expansion-panel [expanded]="this.step?.event?.selectedIndex-1 === 1" hideToggle>
    <mat-expansion-panel-header>
      <mat-panel-title>
        <div class="title_wrap">
          <span class="number">2</span>
          <span class="title">Warehouse Details</span>
        </div>

      </mat-panel-title>
    </mat-expansion-panel-header>
    <div class="wrapper">
      <img src="../../../../assets/img/location_icon.svg" alt="icon" class="icon">
      <div class="wrap">
        <span class="label">Address Line 1*</span>
        <span class="value">{{wareHouseDetail?.main_address?.address_line_1}}</span>
      </div>
    </div>
    <div class="wrapper">
      <img src="../../../../assets/img/home_icon.svg" alt="icon" class="icon">
      <div class="wrap">
        <span class="label">Address Line 2</span>
        <span class="value">{{wareHouseDetail?.main_address?.address_line_2}}</span>
      </div>
    </div>
    <div class="wrapper">
      <img src="../../../../assets/img/city_icon.svg" alt="icon" class="icon">
      <div class="wrap">
        <span class="label">City*</span>
        <span class="value">{{wareHouseDetail?.main_address?.city}}</span>
      </div>
    </div>
    <div class="wrapper">
      <img src="../../../../assets/img/state_icon.svg" alt="icon" class="icon">
      <div class="wrap">
        <span class="label">State*</span>
        <!-- <span class="value">{{detail?.main_address?.state?.state_id_selected?.name}}</span> -->
        <span class="value">{{wareHouseDetail?.main_address?.state_id?.name}}</span>
      </div>
    </div>
    <div class="wrapper">
      <img src="../../../../assets/img/zipcode_icon.svg" alt="icon" class="icon">
      <div class="wrap">
        <span class="label">Zip Code*</span>
        <span class="value">{{wareHouseDetail?.main_address?.zipcode}}</span>
      </div>
    </div>
  </mat-expansion-panel>
</mat-accordion>
